import type { KeyboardEvent } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './Header.module.css';

interface HeaderProps {
  totalOpen: number;
  clientCount: number;
  onCapture: (title: string) => void;
}

export function Header({ totalOpen, clientCount, onCapture }: HeaderProps) {
  const { user, offline, signOut } = useAuth();

  const handleKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onCapture(e.currentTarget.value);
      e.currentTarget.value = '';
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <img src="/mithril-logo.svg" alt="Mithril Media" className={styles.logo} />
        </div>

        <nav className={styles.nav}>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive ? `${styles.navLink} ${styles.navActive}` : styles.navLink
            }
          >
            Board
          </NavLink>
          <NavLink
            to="/clients"
            className={({ isActive }) =>
              isActive ? `${styles.navLink} ${styles.navActive}` : styles.navLink
            }
          >
            Clients
          </NavLink>
        </nav>

        <div className={styles.capture}>
          <span className={styles.capturePrompt}>&gt;</span>
          <input
            type="text"
            onKeyDown={handleKey}
            placeholder="Capture anything — Slack, email, a text… ↵ to triage"
            className={styles.captureInput}
            aria-label="Capture to triage"
          />
        </div>

        <div className={styles.stats}>
          <div className={styles.stat}>
            <div className={styles.statValue}>{totalOpen}</div>
            <div className={styles.statLabel}>OPEN</div>
          </div>
          <div className={styles.divider} />
          <div className={styles.stat}>
            <div className={styles.statValue}>{clientCount}</div>
            <div className={styles.statLabel}>CLIENTS</div>
          </div>
        </div>

        {!offline && user && (
          <button type="button" className={styles.signOut} onClick={() => void signOut()}>
            Sign out
          </button>
        )}
      </div>
    </header>
  );
}
